import { useState, useEffect } from 'react';
import axiosPrivate from 'config/axiosPrivate';

const useConsultantScoreData = (textId, preCalculatedScoreData) => {
  const [scoreData, setScoreData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (
      preCalculatedScoreData &&
      Object.keys(preCalculatedScoreData).length > 0
    ) {
      setScoreData(preCalculatedScoreData);
      setLoading(false);
      setError(null);
      return;
    }

    if (textId && !preCalculatedScoreData) {
      const fetchScoreData = async () => {
        try {
          setLoading(true);
          setError(null);

          const response = await axiosPrivate.get(
            `/texts/${textId}/fullDetails`
          );

          if (response.status === 200 && response.data) {
            const contentScore = response.data.contentScore;
            if (contentScore) {
              setScoreData(contentScore);
            } else {
              // No content score available: expose empty score instead of error
              setScoreData({});
              setError(null);
            }
          } else {
            setError(new Error('Failed to fetch score data'));
          }
        } catch (err) {
          console.error('Error fetching consultant score data:', err);
          setError(
            err.response?.data || err.message || 'Failed to fetch score data'
          );
        } finally {
          setLoading(false);
        }
      };

      fetchScoreData();
    }
  }, [textId, preCalculatedScoreData]);

  return { scoreData, loading, error };
};

export default useConsultantScoreData;
